import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OneStepLink } from 'models';
import { OneStepService } from 'services';

@Injectable({
    providedIn: 'root'
})
export class OneStepLinkResolver implements Resolve<OneStepLink> {
    constructor(private oneStepService: OneStepService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<OneStepLink> {
        const oneStepIdentifier = route.paramMap.get('oneStepIdentifier');
        return this.oneStepService.get(oneStepIdentifier);
    }
}